import { Component, HostBinding, Input } from '@angular/core';

type ButtonColor =
  | 'blue'
  | 'default'
  | 'green'
  | 'post-project'
  | 'red'
  | 'transparent-dark'
  | 'transparent-light'
  | undefined;

type ButtonSize = 'mini' | 'small' | 'large' | 'xlarge' | 'xxlarge' | undefined;

@Component({
  selector: 'fl-button',
  template: `
    <a
      *ngIf="link"
      class="ButtonElement"
      [routerLink]="link"
      [routerLinkActive]="linkActive || ''"
      [routerLinkActiveOptions]="linkActiveOptions || { exact: false }"
      [queryParams]="queryParams"
      [fragment]="fragment"
      [attr.disabled]="(attrDisabled || busy ? true : undefined)"
      aria-live="assertive">
      <ng-container *ngTemplateOutlet="content"></ng-container>
      <fl-spinner
        *ngIf="busy"
        class="LoadingSpinner"
        [size]="'small'"
        [color]="'grey'"
      ></fl-spinner>
    </a>

    <button *ngIf="!link"
      class="ButtonElement"
      [type]="buttonType"
      [attr.disabled]="(attrDisabled || busy ? true : undefined)"
      aria-live="assertive">
        <ng-container *ngTemplateOutlet="content"></ng-container>
        <fl-spinner
          *ngIf="busy"
          class="LoadingSpinner"
          [size]="'small'"
          [color]="'grey'"
        ></fl-spinner>
    </button>

    <ng-template #content>
      <ng-content></ng-content>
    </ng-template>
  `,
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @HostBinding('attr.disabled') attrDisabled: true | undefined;
  buttonType: 'submit' | 'button' = 'button';

  @Input() link?: string;
  @HostBinding('attr.data-busy')
  @Input()
  busy?: boolean;
  @Input() queryParams?: { [k: string]: any };
  @Input() linkActive?: string[] | string;
  @Input() linkActiveOptions?: { exact: boolean };
  @Input() fragment?: string;
  @HostBinding('attr.data-color')
  @Input()
  color: ButtonColor;
  @HostBinding('attr.data-display')
  @Input()
  display: 'block' | 'inline' = 'inline';
  @HostBinding('attr.data-size')
  @Input()
  size: ButtonSize;
  @Input()
  set disabled(value: boolean) {
    this.attrDisabled = value ? true : undefined;
  }
  get disabled() {
    return !!this.attrDisabled;
  }
  @Input()
  set submit(value: boolean) {
    this.buttonType = value ? 'submit' : 'button';
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/ko/webapp/src/app/@shared/ui/button/button.component.ts